import React from "react";
import Breadcrumb2 from "../../../Components/Breadcrumb2/Breadcrumb2";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import AllAcountsSection from "../../../Components/AllAccountsSection/AllAcountsSection";
import { AiOutlineArrowRight, AiOutlineArrowUp } from "react-icons/ai";
import CustomerCare from "../../../Components/CustomerCare/CustomerCare";
import OurStores from "../../../Components/OurStories/OurStores";
import { AiFillCaretRight, AiOutlineRight } from "react-icons/ai";
import { useEffect, useState } from "react";
import axios from 'axios';
import { Link } from "react-router-dom";

const IZBLaunchesIndoDairy = ({ question, answer }) => {
    const BackgroundBrundcrumb = "https://izbassetsmain.blob.core.windows.net/izbwebassets/Image_1.png";
    const img1 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/Forex_Savings.png";

    const ArrowLeft = "https://izbassetsmain.blob.core.windows.net/izbwebassets/LeftArrow.png";
    const ArrowRight = "https://izbassetsmain.blob.core.windows.net/izbwebassets/RightArrow.png";

    function SamplePrevArrow(props) {
        const { className, style, onClick } = props;
        return (
            <img
                src={ArrowLeft}
                className={className}
                style={{
                    ...style,
                    display: "block",
                    width: "50px",
                    height: "50px",
                    left: "-58px",
                    zIndex: "99"
                }}
                onClick={onClick}
            />
        );
    }

    function SampleNextArrow(props) {
        const { className, style, onClick } = props;
        return (
            <img
                src={ArrowRight}
                className={className}

                onClick={onClick}
            />
        );
    }

    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 1,
        nextArrow: <SampleNextArrow />,
        prevArrow: <SamplePrevArrow />,
        initialSlide: 0,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: true,
                },
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    initialSlide: 2,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    };

    return (
        <>
            <Breadcrumb2
                Heading="Latest News"
                img={BackgroundBrundcrumb}
                show={true}

            />

            <section>
                <div className="container pt-5">
                    <h1 className="pb-5 text-left">IZB launches Indo Dairy Production Finance Scheme and Indo Dairy Development Finance!</h1>

                    <p className="pb-3">Indo Zambia Bank (IZB) has launched the Indo Dairy Production Finance Scheme and Indo Dairy Development Finance Scheme in Magoye, Southern Province.</p>

                    <p className="pb-3">Southern Province Permanent Secretary, Dr. Namani H. Monze, commended Indo Zambia Bank for introducing innovative products that align with Government efforts to diversify agriculture and promote sustainable, year-round productivity. He encouraged farmers to take full advantage of the schemes, emphasised discipline and responsibility, and assured continued Government support to strengthen the dairy sector and improve rural livelihoods.</p>

                    <p className="pb-3">Indo Zambia Bank Managing Director, Brajesh Kumar Singh, highlighted that the Indo Dairy Production Finance Scheme is meant to help smallholder farmers maintain and increase milk production by providing short-term financing for feed, veterinary care and equipment, ensuring healthier animals and higher quality milk. He added that the Indo Dairy Development Finance Scheme will help support long-term farm growth and infrastructure, empowering farmers to scale operations, modernise practices, and improve competitiveness.</p>

                    <p className="pb-3">These initiatives represent a partnership between the private sector and Government to empower farmers, boost the dairy industry, and drive sustainable economic growth across Zambia.</p>

                    <p className="pb-3"><b><em>#IndoZambiaBank #DairyDevelopment #EmpoweringFarmers #MagoyeLaunch #SustainableGrowth #AgricultureFinance #DairyFarming</em></b></p>



                    <h2 className="pt-4 pb-4">Gallery</h2>

                    <div className="test news-slider-list-slider row align-items-center pb-4">
                        <Slider {...settings}>
                            <div>
                                <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/izb-launches-indo-dairy-production-finance-scheme-and-indo-dairy-development-finance-banner-1.jpg" alt="IZB launches Indo Dairy Production Finance Scheme and Indo Dairy Development Finance!" />
                            </div>
                            <div>
                                <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/izb-launches-indo-dairy-production-finance-scheme-and-indo-dairy-development-finance-banner-2.jpg" alt="IZB launches Indo Dairy Production Finance Scheme and Indo Dairy Development Finance!" />
                            </div>
                            <div>
                                <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/izb-launches-indo-dairy-production-finance-scheme-and-indo-dairy-development-finance-banner-3.jpg" alt="IZB launches Indo Dairy Production Finance Scheme and Indo Dairy Development Finance!" />
                            </div>
                            <div>
                                <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/izb-launches-indo-dairy-production-finance-scheme-and-indo-dairy-development-finance-banner-4.jpg" alt="IZB launches Indo Dairy Production Finance Scheme and Indo Dairy Development Finance!" />
                            </div>
                            <div>
                                <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/izb-launches-indo-dairy-production-finance-scheme-and-indo-dairy-development-finance-banner-5.jpg" alt="IZB launches Indo Dairy Production Finance Scheme and Indo Dairy Development Finance!" />
                            </div>
                            <div>
                                <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/izb-launches-indo-dairy-production-finance-scheme-and-indo-dairy-development-finance-banner-6.jpg" alt="IZB launches Indo Dairy Production Finance Scheme and Indo Dairy Development Finance!" />
                            </div>
                            <div>
                                <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/izb-launches-indo-dairy-production-finance-scheme-and-indo-dairy-development-finance-banner-7.jpg" alt="IZB launches Indo Dairy Production Finance Scheme and Indo Dairy Development Finance!" />
                            </div>
                            <div>
                                <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/izb-launches-indo-dairy-production-finance-scheme-and-indo-dairy-development-finance-banner-8.jpg" alt="IZB launches Indo Dairy Production Finance Scheme and Indo Dairy Development Finance!" />
                            </div>
                        </Slider>
                    </div>
                </div>



            </section>

            <CustomerCare />
            <OurStores />

        </>
    );
};

export default IZBLaunchesIndoDairy;